import React from 'react';
import DatePicker from "react-datepicker";
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";

/**
 * Date Range Picker component for selecting start and end dates
 * @param {Object} props - Component props
 * @param {Object} props.dateRange - Object containing startDate and endDate
 * @param {Function} props.setDateRange - Function to update date range
 */
const DateRangePicker = ({ dateRange, setDateRange }) => {
  return (
    <div className="cashup-date-range-picker">
      <div className="cashup-date-picker">
        <DatePicker
          popperPlacement="bottom-start"
          selected={moment(dateRange.startDate, 'DD/MM/YYYY').toDate()}
          onChange={(date) => setDateRange({...dateRange, startDate: moment(date).format('DD/MM/YYYY')})}
          dateFormat={"dd-MM-yyyy"}
          aria-label="Start date"
          className="cashup-date-input"
        />
      </div>
      <span className="dash">-</span>
      <div className="cashup-date-picker">
        <DatePicker
          popperPlacement="bottom-end"
          selected={moment(dateRange.endDate, 'DD/MM/YYYY').toDate()}
          onChange={(date) => setDateRange({...dateRange, endDate: moment(date).format('DD/MM/YYYY')})}
          dateFormat={"dd-MM-yyyy"}
          aria-label="End date"
          className="cashup-date-input"
        />
      </div>
    </div>
  );
};

export default DateRangePicker;